<template>
  <el-container>
    <el-header height="212px">
      <div class="borderT">
          <div class="sevcont">
            <div class="left">
            <p>24小时服务热线：0755-83458333</p>
            <el-dropdown class='dropdown'>
              <a class="el-dropdown-link">{{currentParkName}}<i class="el-icon-arrow-down el-icon--right"></i></a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(v, i) in parkList" :key="i">
                  <a class="abloak" :href="taUrl.pcUrl+'/index?parkId='+v.parkId">{{v.parkName}}</a>
                </el-dropdown-item>
                <!-- <el-dropdown-item disabled>深圳龙岗天安数码新城</el-dropdown-item> -->
               
                <!-- <el-dropdown-item>
                  <a class="abloak" href="http://www.tianans.com/?parkId=1000">福田天安数码城</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a class="abloak" href="http://www.tianans.com/?parkId=1001">重庆天安数码城</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a class="abloak" href="http://www.tianans.com/?parkId=1004">东莞天安数码城</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a class="abloak" href="http://www.tianans.com/?parkId=1005">广州番禺节能科技园</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a class="abloak" href="http://www.tianans.com/?parkId=1006">宝安深业U中心</a>
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <a class="abloak" :href="taUrl.pcUrl+'/alliance'">西理工校企联盟</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <a style='color:#f12229' class="oldhome" :href="'http://www.tianans.com/?parkId='+this.currentParkId">切换新平台</a>
            </div>
            <div class="right">
              <div class="login" v-if='!token'>
                <router-link to="/navigator/auth/regist">注册</router-link>
                <router-link to="/navigator/auth/login">登录</router-link>
              </div>
              <el-dropdown class='dropdown' @command="handleCommand" v-else>
                <span class="el-dropdown-link" @click.stop='toPersonal'>
                  {{ user.userNick || user.userMobile }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item"
                                    v-for="item in user.bindParkInfo"
                                    :key="item.parkId">
                    园区后台({{ item.parkNameAcronym }})
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if='user.bindCorpInfo && user.bindCorpInfo.parkId'
                    command="corp">
                    企业后台
                  </el-dropdown-item>
                  <el-dropdown-item command="por">个人中心</el-dropdown-item>
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="gongzhonghao">
                公众号
                <img src="../../assets/homePage/qrcode.png">
              </div>
            </div>
          </div>
      </div>
      <div class="align-center-main center-bar">
        <router-link to="/" class="logo">
            <img src="../../static/image/logo.png">
        </router-link>
        <form action="https://www.baidu.com/s">
          <input class="baidutext" type="text" name="wd" placeholder="请输入关键词..."/><input class="sous" type="submit"  value="搜索"/>
        </form>
      </div>
      <div class="align-center-main center-bar">
        <nav>
          <router-link to="/index">首页</router-link>
          <router-link class="newimg" :to="{path: `/navigator/property/${commonService.newCarCard}`}"><img width="40" src="@/assets/homePage/icon-hot.png">在线物业</router-link>
          <!-- <router-link :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.houseProperty}`}">房产租售</router-link> -->
          <router-link :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.advertisingPosition}`}">商务服务</router-link>
          <router-link class="newimg" to="/navigator/financePlatform/financeList"><img width="40" src="@/assets/homePage/icon-hot.png">金融服务</router-link>
          <router-link to="/navigator/parkCompleteSet/activity">园区配套</router-link>
          <router-link to="/navigator/corpList">园区企业</router-link>
          <router-link to="/navigator/humanResource/sort/jobList">园区招聘</router-link>
          <router-link :to="{ path: '/shoppingMall/mall'}">天安商城</router-link>
         
        </nav>
      </div>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <Footer/>
      <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg="tipsMsg"/>

  </el-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import taUrl from '@/static/backstageUrl';
import Footer from '../../components/Footer';
import commonService from '@/static/commonService';

export default {
  data() {
    return {
      taUrl: taUrl,
      commonService: {},
      currentParkName: '',
      submitSuccessFlag: false,
      tipsMsg: '登陆状态已失效，请重新登陆',
      parkList: [],
    }
  },
  methods: {
    ...mapMutations(['change_token', 'change_user', 'change_parkInfo', 'change_currentParkId']),
    handleCommand(command) {
      let token = encodeURIComponent(this.token);
      switch(command) {
        case 'corp':
          window.open(`${taUrl.corpUrl}/#/usertoken?token=${token}&park_id=${this.user.bindCorpInfo.parkId}&corp_id=${this.user.bindCorpInfo.corpId}`);
          // window.open(`http://localhost:8000/#/usertoken?token=${token}&park_id=${this.user.bindCorpInfo.parkId}&corp_id=${this.user.bindCorpInfo.corpId}`);
          break;
        case 'logout':
          this.logoutUser();
          break;
        case 'por':
          this.toPersonal();
        break;
        default:
        // 园区后台
          window.open(`${taUrl.parkUrl}/#/user?token=${token}&park_id=${command.parkId}`);
          // window.open(`http://localhost:8080/#/user?token=${token}&park_id=${command.parkId}`);
          break;
      }
    },
    toPersonal() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        // console.log(response);
        if (res.resCode === '10000') {
          this.$router.push({ path: '/navigator/personal/info', });
        } else if (res.resCode === '10004') {
          this.change_token('');
          this.change_user('');
          this.submitSuccessFlag = true;
        }
      });
    },
    getUserInfo() {  // 获取用户详情
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        }
      });
    },
    getTel() {  // 获取电话
      this.$http.post(`${this.URL_PREFIX}/mgmt/park/index/park`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          console.log(res);
        }
      });
    },
    chereParkId() {  // 修改用户所属园区
      const $parkId = parseInt(location.href.split('parkId=')[1]?location.href.split('parkId=')[1]:this.currentParkId);
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info`, {
        parkId: $parkId,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          console.log(res);
        }
      });
    },
    getParks() {  // 获取园区列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/info/list`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.parkList = res.resData.pageList ? res.resData.pageList : [];
          if(this.parkList.length){
            this.parkList.forEach((v, i)=>{
              if(v.parkId == this.currentParkId){
                this.change_parkInfo(v);
                this.currentParkName = v.parkName;
              }
            })
          }
        }
      });
    },
    logoutUser() {
      this.$http.post(`${this.URL_PREFIX}/app/user/logout`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token('');
          this.change_user('');
          this.$router.push({ path: '/navigator/auth/login' });
        }
      });
    }
  },
  components: {
    Footer
  },
  computed: {
    ...mapGetters(['token', 'user', 'currentParkId', 'parkInfo']),
  },
  created() {
    if (this.token) {
      this.getUserInfo();
    }
    this.getParks();
    // this.getTel();
    this.chereParkId();
    this.$root.eventHub.$on('clearToken', (errMsg) => {
      this.change_token('');
      this.change_user('');
      // if (errMsg !== 'noMsg') {
      //   this.submitSuccessFlag = true;
      // }
    });
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  }
}
</script>



<style scoped lang="scss">
  @import "~@scss";
  .oldhome{
    color: #fff;
    margin-left: 20px;
  }
  .abloak{
    display: block;
    width: 100%;
  }
  .el-header{
    background-color: #151515;
    padding: 0px;
    .align-center-main{
      width: 1200px;
      margin: 0 auto;
      z-index: 9;
      // position: relative;
    }
    .borderT{
      display: flex;
      width: 100%;
      height: 40px;
      background: #2b2b2b;
      // position: absolute;
      // top: 0px;
      // z-index: 1;
      .sevcont{
        width: 1200px;
        height: 40px;
        margin: 0 auto;
        flex-direction: row;
        justify-content: space-between;
        display: flex;
        align-items: center;
        .left{
          display: flex;
          .dropdown{
            height: 100%;
            cursor: pointer;
            color: #FFFFFF;
            margin-left: 32px;
            a{
              color: #fff;
            }
            .el-dropdown-link{
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          p{
            color: #fff;
            line-height: 20px;
          }
        }
        .right{
          display: flex;
          color: #fff;
          height: 100%;

          .gongzhonghao{
            cursor: pointer;
            margin: 0 20px;
            display: flex;
            align-items: center;
            height: 100%;
            position: relative;
              img{
                display: none;
                margin-left: -45px;
                position: absolute;
                top: 60px;
                z-index: 999999;
              }
            &:hover img{
              display: block;
            }
          }
          .dropdown{
            height: 100%;
            cursor: pointer;
            color: #FFFFFF;
            margin-left: 32px;
            a{
              color: #fff;
            }
            .el-dropdown-link{
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
        }
        .login{
          display: flex;
          height: 100%;
          align-items: center;
          & > a{
            font-size: 16px;
            color: #fff;
            line-height: 1;
            &:hover{
              color: #999;
            }
          }
          & > a{
            padding: 0 10px;
            border-right: 1px solid #fff;

            &:last-child{
              border-right: none;
            }
          }
        }
      }
    }
    .center-bar{
      margin-top: 20px;
      height: 72px;
      display: flex;
      align-items: center;
      nav{
        width: 100%;
        height: 50px;
        display: flex;
        // justify-content: center;
        align-items: center;
        background: #262321;
        .newimg{
          position: relative;
          img{
            position: absolute;
            top: -12px;
            left: 65px;
          }
        }
        a.logo img{
          width: 253px;
          margin-right: 20px;
        }
        a:not(.logo){
          display: flex;
          align-items: center;
          padding: 16px 22px;
          font-family: RobotoMedium;
          font-size: 14px;
          color: #fff;
          height: 60%;
          box-sizing: border-box;
          border-bottom: 2px solid transparent;
          &:hover, &.router-link-active{
            // border-color: $color-red;
            // background: rgba(50, 50, 50, 0.5);
            color: #ffaa00;
            border-radius: 2px;
          }
        }
      }

      

      

    }
  }

  .el-main {
    background-color: #f6f6f6;
    color: #151515;
    padding: 0;
  }

  .el-container {
    min-height: 100%;
    min-width: 732px;
  }

  .el-main{
    position: relative;
    // min-height: 680px;
  }

  .submit-success {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .baidutext{
    background: #403e3c;
    color: #eae5e5;
    border: none;
    width: 300px;
    height: 40px;
    margin-left: 100px;
    text-indent:10px;
  }
  .sous{
    background: #d9262c;
    border: none;
    height: 40px;
    width: 50px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/navigator/Navigator.vue